import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Tooltip } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    role: {
        color: '#09205C'
    },
    moreRoles: {
        color: '#3076CA',
        cursor: 'pointer'
    }
}));

export default function RoleDisplay(props) {
    const classes = useStyles();
    const {roles} = props

    return (
        <Box component="span">  
        {roles.length == 1 ?
            <Box component="span"> {roles[0].charAt(0) + roles[0].slice(1).toLocaleLowerCase()} </Box>
        :
            <Box component="span" className={classes.role}> 
                {roles[0].charAt(0) + roles[0].slice(1).toLocaleLowerCase()}
                <Tooltip title={roles.slice(1, roles.length).join(', ').toLocaleLowerCase()} arrow>
                    <span className={classes.moreRoles}>
                        {` + ${roles.length - 1}  more `}
                    </span> 
                </Tooltip>
            </Box>
        }
        </Box>
    )
}
